export enum RequestedForEnum {
  PROMO = "promo",
  TRIAL = "trial",
  SUBSCRIPTION = "subscription",
  OMS = "ONE_MEAL_SERVICE",
  STARCLEANER = "star-cleaner",
  DISCOUNT_COUPON = "discount-coupon",
  COUPON_EXPIRY_EXTENSION = "coupon-expiry-extension",
  PLATFORM_LEAD = "platform-lead",
  MARKET_PLACE = "market-place-order",
  CHEF_FOR_PARTY = 'chef-for-party',
  ONE_MEAL_SERVICE_TIME_EXTENSION = 'one-meal-service-time-extension'
}
